<template>
  <div>
    <label>Find your project, portfolio faster.</label>
      <input class="form-control" type="text" v-model="searchInput" placeholder="Search for project or portfolio">
  </div>
</template>

<style>
</style>

<script>

export default {
  components: {
  },
  props: ['search'],
  name: 'SearchProjectBox',
  methods: {
  },
  mounted () {
  },
  data () {
    return {
      searchInput: null
    }
  },
  watch: {
    searchInput: function (value) {
      this.$emit('input', value)
    }
  },
  beforeMount () {
    this.searchInput = this.search
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/SearchProjectBox.vue